import React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "moment/locale/da";
import { Helmet } from "react-helmet";

export default props => (
    <>
        <DayPickerInput
            formatDate={formatDate}
            parseDate={parseDate}
            format="LL"
            placeholder={`${formatDate(new Date(), "LL", "it")}`}
            dayPickerProps={{
                locale: "da",
                localeUtils: MomentLocaleUtils
            }}
            inputProps={{
                style: {
                    minWidth: 100,
                    border: "none",
                    backgroundColor: "#F0F0F0",
                    borderRadius: "10px",
                    marginRight: "10px",
                    paddingLeft: "5px",
                    outline: "none",
                    height: "100%"
                }
            }}
            style={{ height: "100%" }}
            onDayChange={props.changeValue}
        />
        <Helmet>
            <style>{`
                    .DayPickerInput > input::placeholder {
                        color: black;
                    }
                `}</style>
        </Helmet>
    </>
);
